import React, { SFC } from 'react';
import {
    FeaturedStoryCollectionItemFragment
} from '../../../entities/operationResults';
import FeaturedPreview from '../../molecules/FeaturedEntryPreview';
import styled from '../../../styled-components';
import gql from 'graphql-tag';

import { format } from 'date-fns';

const formatDate = (dateString: string, formatString = "DD MMMM YYYY", timezone = "Europe/Amsterdam") => {
    const date = new Date(dateString);
    // You can use a library like 'date-fns-tz' for timezone handling if needed
    return format(date, formatString);
};

interface Props {
    collectionItems: FeaturedStoryCollectionItemFragment[] | null;
}

const storyFragment = gql`
    fragment FeaturedStoryCollectionItem on story_Entry {
        id
        uri
        title
        description {
            html
        }
        heroImage {
            srcSmall: url(transform: "storyHeroSmall")
            widthSmall: width(transform: "storyHeroSmall")
            srcMedium: url(transform: "storyHeroMedium")
            widthMedium: width(transform: "storyHeroMedium")
            srcLarge: url(transform: "storyHeroLarge")
            widthLarge: width(transform: "storyHeroLarge")
            title
        }
        postDate
    }
`;

export const fragments = {
    relatedStory: storyFragment,
};

const CollectionFeaturedItems: SFC<Props> = ({ collectionItems }) => {
    return (
        <PreviewWrap>
            {collectionItems !== null && collectionItems.map(({ id, title, uri, heroImage, postDate }) => {
                const firstImage = heroImage && heroImage[0];
                return uri && (
                    <FeaturedPreview
                        key={id || ''}
                        link={'/' + uri}
                        img={firstImage ? {
                            title: firstImage.title,
                            srcSmall: firstImage.srcSmall,
                            widthSmall: firstImage.widthSmall !== null ? firstImage.widthSmall.toString() : null,
                            srcMedium: firstImage.srcMedium,
                            widthMedium: firstImage.widthMedium !== null ? firstImage.widthMedium.toString() : null,
                            srcLarge: firstImage.srcLarge,
                            widthLarge: firstImage.widthLarge !== null ? firstImage.widthLarge.toString() : null
                        } : undefined}
                        date={postDate && formatDate(postDate, "DD MMMM YYYY", "Europe/Amsterdam")}
                    >
                        {title}
                    </FeaturedPreview>
                );
            })}
        </PreviewWrap>
    );
};

const PreviewWrap = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    flex-direction: column;
    @media screen and (min-width: ${(props) => props.theme.mediaQueries.m}) {
        flex-direction: unset;
    }
`;

export default CollectionFeaturedItems;
